export default __webpack_public_path__ + "96a1549308b0c93c87f191d8a65614e5.png";